import React from "react";
import { Navigate, Route, Routes, useLocation } from "react-router-dom";
import { readStoredUser } from "../utils/sessionUser";
import AnalyticsPanel from "./AnalyticsPanel";
import AnalyticsSettings from "./pages/AnalyticsSettings";
import CostControl from "./pages/CostControl";
import Forecasting from "./pages/Forecasting";
import SalesByFamily from "./pages/SalesByFamily";
import "../pos/pos.css";
import "./analytics.css";

function RedirectToSales() {
  const location = useLocation();
  return <Navigate to={`/analytics/sales${location.search || ""}`} replace />;
}

export default function AnalyticsApp() {
  const user = readStoredUser();
  const allowedModules = Array.isArray(user?.allowed_modules) ? user.allowed_modules : [];
  const isAdmin = Number(user?.id) === 1;
  const canAccess =
    isAdmin ||
    allowedModules.includes("analytics") ||
    allowedModules.includes("control_gestion");

  if (!canAccess) {
    return <Navigate to="/select-module" replace />;
  }

  return (
    <Routes>
      <Route element={<AnalyticsPanel />}>
        <Route path="sales" element={<SalesByFamily />} />
        <Route path="cost-control" element={<CostControl />} />
        <Route path="forecasting" element={<Forecasting />} />
        <Route path="settings" element={<AnalyticsSettings />} />
        <Route path="*" element={<RedirectToSales />} />
      </Route>
    </Routes>
  );
}
